import { get, post } from '../axios'

// 获取BBS最新的
export function v1_bbs_getNews_get(map, option) {
  return get(`${process.env.VUE_APP_V1}/v1/bbs/getNews`, map, option).then(
    response => response
  )
}
